const config = {
  baseUrl: window.env?.GR_API_URL,
  grWebUrl: window.env?.GR_WEB_URL,
  ssoWebUrl: window.env?.SSO_WEB_URL,
  ssoClientId: window.env?.SS0_GR_CLIENT_ID,
  gestaoConformidadesUrl: window.env?.GESTAO_CONFORMIDADES_URL,
  useFixture: false
}

export default config
